import React from 'react';
import { createUseStyles } from 'react-jss';
import colors from '@packages/core/styles/colors';
import { Typography, Button } from '@packages/ui/shared';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const useStyles = createUseStyles({
    associateVehicleStyles: {
        borderTop: `1px solid ${colors.grayThree}`,
        width: '100%',
        padding: '20px 0px 20px 0px',
        display: 'flex',
        justifyContent: 'space-between',
    },
});

interface Props {
    headerText: string;
    buttonText?: string;
    styleProps?: React.CSSProperties;
    onClick?: any;
    AssociatedVehicles?: React.ReactNode;
    AssociatedPublications?: React.ReactNode;
    buttonDisable?: boolean;
}

export const AssociateSections = ({
    headerText,
    buttonText,
    styleProps,
    onClick,
    AssociatedVehicles,
    AssociatedPublications,
    buttonDisable = false,
}: Props) => {
    const classes = useStyles();

    return (
        <>
            <div className={classes.associateVehicleStyles} style={styleProps}>
                <Typography
                    style={{
                        fontFamily: 'Roboto',
                        fontWeight: '600',
                        fontSize: 21,
                        lineHeight: 32,
                        letterSpacing: 0,
                    }}
                >
                    {headerText}
                </Typography>

                {!buttonText ? null : buttonDisable ? (
                    <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 400 }}
                        trigger={['hover', 'focus']}
                        overlay={
                            <Tooltip
                                id={'1'}
                                style={{
                                    fontSize: 16,
                                    padding: '8px 12px',
                                    textAlign: 'center',
                                }}
                            >
                                {
                                    'You can associate only one vehicle, please edit or remove that vehicle to associate vehicle'
                                }
                            </Tooltip>
                        }
                    >
                        <span>
                            <Button variant="primary" style={{ pointerEvents: 'none' }} disabled>
                                {buttonText}
                            </Button>
                        </span>
                    </OverlayTrigger>
                ) : (
                    <Button variant="primary" onPress={onClick} disabled={buttonDisable}>
                        {buttonText}
                    </Button>
                )}
            </div>
            {typeof AssociatedVehicles !== 'undefined' && AssociatedVehicles}
            {typeof AssociatedPublications !== 'undefined' && AssociatedPublications}
        </>
    );
};
